<script setup>
  import { ref, computed, watch, onMounted, watchEffect } from 'vue';
  import { useUserStore } from '@/stores/UserStore'
  import BaseModal from './base/BaseModal.vue';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    containerId: {
      type: [Number, Array],
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();

  const containerIdArray = ref([]);
  const showModal = ref(false);

  const containerName = computed(() => {
    if (containerIdArray.value.length === 0) return 'N/A';

    const containerNames = containerIdArray.value.map(containerId => {
      const container = userStore.getContainerById(containerId);

      if (!container) return null;

      return `<li><strong>${container.container_name}</strong></li>`;
    }).filter(container => container).join('');

    return `<ul>${containerNames}</ul>`;
  });

  const deleteText = computed(() => {
    if (containerIdArray.value.length === 0) return 'There are no containers selected for deletion.';

    const deleteCountText = containerIdArray.value.length === 1 ? 'this container' : `these ${containerIdArray.value.length} containers`;

    return `Are you sure you want to delete ${deleteCountText}:${containerName.value}`;
  })

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function handleDeleteContainer() {
    await userStore.deleteContainers(containerIdArray.value);
    await userStore.getProfiles(true);

    const toastMessage = containerIdArray.value.length === 1
      ? `Deleted container ${containerName.value}`
      : `Deleted ${containerIdArray.value.length} containers.`

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: toastMessage,
      })
    }        

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });

  watch(() => props.containerId, () => {
    containerIdArray.value = Array.isArray(props.containerId) ? props.containerId : [props.containerId];
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Delete Favorite Container?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <p class="jwx-modal__text" v-html="deleteText"></p>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Cancel
        </button>
        <button 
          type="button" 
          @click.prevent="handleDeleteContainer"
          class="jwx-button jwx-button--danger"
        >
          Delete
        </button>
      </div>
    </div>
  </BaseModal>
</template>